// In-plane displacement, shared by both motion models.
//
// `displace` writes the z column; this writes x and y. Which direction a
// sample is pushed is not something the field can say on its own — a value is
// a scalar — so `axis` names it:
//
//   radial    out from the centre        rings rippling
//   x / y     one fixed axis             rows bending, walls waving
//   gradient  up the field's slope       general warping, costs the gradient
//
// Returns a fresh object rather than mutating: the substrate's lattice is
// shared across frames and must not drift.
export function inPlane(axis, x, y, amount, gradient) {
  if (axis === 'x') return { x: x + amount, y }
  if (axis === 'y') return { x, y: y + amount }
  if (axis === 'gradient') {
    return { x: x + Math.cos(gradient) * amount, y: y + Math.sin(gradient) * amount }
  }
  // Radial. At the exact centre there is no outward direction, so the sample
  // stays put rather than picking one arbitrarily.
  const r = Math.sqrt(x * x + y * y)
  if (r < 1e-9) return { x, y }
  return { x: x + (x / r) * amount, y: y + (y / r) * amount }
}
